import { Panel, Container } from '@repo/ui'
import { observer } from 'mobx-react-lite'
import React from 'react'
import { useHistory } from 'react-router-dom'

import { AppHeader } from '@/components/AppHeader'
import { BackButton, CloseButton } from '@/components/icon-buttons/IconButtons'
import { Main } from '@/components/Main'
import { Page } from '@/components/Page'
import { PageHeading } from '@/components/PageHeading'
import { AccountSettings } from '@/pages/settings/components/AccountSettings'

export const AccountSettingsGameLevelRoute = observer(
  function AccountSettingsGameLevelRoute(): React.ReactElement {
    return <AccountSettingsGameLevelPage />
  }
)

const AccountSettingsGameLevelPage = observer(
  function AccountSettingsGameLevelPage(): React.ReactElement {
    const history = useHistory()

    const handleClickBack = () => {
      history.goBack()
    }

    const handleClickClose = () => {
      history.push('/game')
    }

    return (
      <Page title='Account Settings'>
        <AppHeader
          actionsLeft={<BackButton onClick={handleClickBack} />}
          actionsRight={<CloseButton onClick={handleClickClose} />}
          header={<PageHeading>Account Settings</PageHeading>}
        />

        <Main>
          <Container size='medium'>
            <Panel>
              <AccountSettings />
            </Panel>
          </Container>
        </Main>
      </Page>
    )
  }
)
